export default __webpack_public_path__ + "static/media/nut.652af97d.svg";